import { useSelector } from "react-redux";
import { selectIsExceptionsLoading, selectViewMode } from "../../shared/store/reducers/OverviewReducer";
import { Skeleton } from "@nike/eds";

export const ExceptionsCounter = ({ exceptionsLength }: { exceptionsLength: number }) => {
    const isExceptionsLoading = useSelector(selectIsExceptionsLoading) as boolean;
    const viewMode: 'BATCHES' | 'PROBLEMS' = useSelector(selectViewMode);

    if(viewMode === 'PROBLEMS') return <></>;
    return (
            isExceptionsLoading ? (
                <Skeleton height="20px" width="20px" radius={"rounded"} />
            ) : (
                <div className="error-counter">  {exceptionsLength} </div>
            )
        );
};